import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    selectors: {
      '.ms-Dialog-title': {
        paddingTop: pxToRem(32),
        paddingBottom: pxToRem(12),
      },
      '.ms-Dialog-inner': {
        paddingBottom: pxToRem(32),
      },
      '.ms-Dialog-actions': {
        marginTop: pxToRem(24),
      },
    },
  },
  modalText: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    selectors: {
      a: {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
      'a:hover': {
        textDecoration: 'underline',
      },
    },
  },
});
